import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import { UnregisteredReposClient, unregisteredReposApiRef } from './api';

/**
 * Unregistered Repositories Frontend Plugin
 *
 * This plugin provides a user interface for managing repositories
 * that don't have catalog-info.yaml files in the Backstage software catalog.
 */
export const unregisteredReposPlugin = createPlugin({
  id: 'unregistered-repos',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: unregisteredReposApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) => {
        return new UnregisteredReposClient({ discoveryApi, fetchApi });
      },
    }),
  ],
});

/**
 * Main page component for the unregistered repositories plugin
 */
export const UnregisteredReposPage = unregisteredReposPlugin.provide(
  createRoutableExtension({
    name: 'UnregisteredReposPage',
    component: () => import('./components/UnregisteredReposPage').then(m => m.UnregisteredReposPage),
    mountPoint: rootRouteRef,
  }),
);
